import mojs from 'mo-js';

class Heart extends mojs.CustomShape {

  getShape () {
    return '<path d="m49.109714,24.23141c20.034994,-57.477384 98.532758,0 0,73.899494c-98.532758,-73.899494 -20.034994,-131.376878 0,-73.899494z""></path>';
  }
}

export class LikeEvent {

  static animateLikesForId (buttonId, iconId, onComplete = null) {

    const button = document.getElementById(buttonId);
    const icon = document.getElementById(iconId);

    const tlDuration = 300;

    mojs.addShape('heart', Heart);

    const triangleBurst = new mojs.Burst({
      parent: button,
      radius: { 30: 75 },
      count: 5,
      angle: 30,
      children: {
        shape: 'heart',
        radius: { 4: 0 },
        scale: 3,
        angle: 270,
        delay: 30,
        speed: 0.15,
        easing: mojs.easing.bezier(0.1, 1, 0.3, 1),
        duration: tlDuration
      }
    });

    const scaleButton = new mojs.Html({
      el: `#${buttonId}`,
      duration: tlDuration,
      scale: { 1.3: 1 },
      easing: mojs.easing.out,
    });

    button.style.transform = 'scale(1, 1)';

    const animationTimeline = new mojs.Timeline();
    animationTimeline.add([
      triangleBurst,
      scaleButton
    ]);

    function repeat () {
      animationTimeline.replay();
      if (!!icon.classList) {
        icon.classList.add('checked');
      }
    }

    repeat();
    setTimeout(() => {
      if (onComplete) {
        onComplete();
      }
    }, tlDuration + 50);

  }

}
